import React from 'react'

const SoGehtBestpreisSection = () => (
  <section id="sliderSection">
    <div className="relative px-5 py-12 text-white bg-gray-700 lg:py-24">
      <div className="absolute z-0">
        <img src="/images-optimized/birne.gif" className="max-w-[175px] sm:max-w-none z-0" alt="" />
      </div>
      <section className="container relative z-10 mx-auto" id="so-geht-autoverkaufen">
        <div className="flex flex-col lg:flex-row">
          <div className="w-full">
            <h3 className="text-2xl font-bold text-center lg:mt-20 lg:text-right lg:pr-8">
              So geht <span className="text-brand-lime">autoverkaufen.de</span>
            </h3>
            <p className="mt-8 text-center text-md lg:text-right lg:pr-8 lg:mt-16 lg:mb-16">
              Wetten, dass der Autoverkauf mit <br className="hidden lg:inline" />
              <span className="text-brand-lime">autoverkaufen.de</span> kinderleicht ist? <br className="hidden lg:inline" />
              In nur 90 Sekunden erf&auml;hrst du in unserem <br className="hidden lg:inline" />
              Erkl&auml;rvideo alles, was du wissen musst.
            </p>
          </div>
          <div className="w-full">
            <video
              src="https://s3.eu-central-2.wasabisys.com/av-static-content/Film.mp4"
              loading="lazy"
              className="rounded-10"
              controls
              poster="/images-optimized/Film.gif"
            >
              <img alt="zuverl&auml;ssig" className="xl:rounded-10" src="/images-optimized/Film.gif" />
            </video>
          </div>
        </div>
      </section>
    </div>

    <section>
      <div className="container px-5 py-12 mx-auto lg:pb-0">
        <div className="flex flex-col-reverse lg:flex-row">
          <div className="flex justify-center lg:min-w-[800px]">
            <div className="embed-container ratio14x11">
              <iframe
                className="lazy"
                scrolling="no"
                src="/ani/bestpreis/frame.htm"
                width="700"
                height="550"
                title="Bestpreis Animation"
              ></iframe>
            </div>
          </div>
          <div className="mb-6 lg:mb-0 lg:pt-12">
            <h3 className="mb-10 text-3xl font-bold text-center text-gray-800 lg:text-left">
              Verkauf dein Auto nur zum Bestpreis
            </h3>
            <p className="mb-8 text-sm font-bold">
              Autoverkauf ist Vertrauenssache. Wir von
              <span className="text-brand-fuchsia">autoverkaufen.de</span>
              stehen f&uuml;r eine professionelle Preisbewertung und wollen all unseren Kunden ein faires Angebot f&uuml;r ihr Fahrzeug machen.
            </p>
            <p className="mb-10 text-sm">
              F&uuml;r unsere Bestpreisermittlung ber&uuml;cksichtigen wir eine Vielzahl von Faktoren. Unser Expertenteam greift auf einen gro&szlig;en Erfahrungsschatz zur&uuml;ck. Dabei holen wir uns zus&auml;tzlich Unterst&uuml;tzung von mehreren kompetenten Partnern wie bspw. DEKRA und mobile.de, die unseren Pricing-Algorithmus mit zus&auml;tzlichen Daten anreichern.
            </p>
            <div className="flex justify-center lg:justify-start">
              <a href="#faq" className="px-8 py-2 font-bold text-center text-white rounded-full bg-azure hover:bg-azure-dark">
                Weitere Infos
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
)

export default SoGehtBestpreisSection
